import {
    APPLY_ATT_LABEL,
    BulkRecommendationType,
    BulkUpdateAction,
    BulkUpdateDirection,
    BulkUpdateType
} from '../../../utils/bulkUpdateUtils';
import { BulkProtectionOptions, DirectionFilterNames } from '../../../utils/enums';
import { IconType } from '../custom-icon/custom-icon';

export interface PolicyMenuItem {
    key: string;
    icon?: IconType;
    label: string;
    iconSize?: number;
    selectable?: boolean;
    isSub?: boolean;
    children?: any[] | null;
    updateType?: BulkUpdateType | BulkRecommendationType;
    updatedAction?: BulkUpdateAction;
    updateDirection?: BulkUpdateDirection;
    modalConfirmInfo?: { text: string, title: string, okButtonText: string };
}

export const BulkMenuItems: Partial<Record<BulkProtectionOptions, PolicyMenuItem[]>> = {
     [BulkProtectionOptions.GEO_FILTERING]: [
        {
            label: APPLY_ATT_LABEL,
            key: 'geo-att',
            icon: IconType.APPLY_ATT,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkRecommendationType.COUNTRY,
            updatedAction: BulkUpdateAction.RECOMMENDATION
        },
        {
            label: 'Block All Countries',
            key: 'geo-block',
            icon: IconType.BLOCK_ICON,
            iconSize: 18,
            selectable: false,
            children: [
                {
                    label: DirectionFilterNames.OUTBOUND,
                    key: 'geo-block-in',
                    icon: IconType.FROM_NETWORK,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.OUTBOUND
                },
                {
                    label: DirectionFilterNames.INTBOUND,
                    key: 'geo-block-out',
                    icon: IconType.FROM_INTERNET,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.INTBOUND
                },
                {
                    label: DirectionFilterNames.BOTH,
                    key: 'geo-block-both',
                    icon: IconType.ARROW_BOTH,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.BOTH
                }
            ]
        },
        {
            label: 'Allow All Countries',
            key: 'geo-allow',
            icon: IconType.ALLOW_ICON,
            iconSize: 18,
            selectable: false,
            isSub: false,
            children: [
                {
                    label: DirectionFilterNames.OUTBOUND,
                    key: 'geo-allow-in',
                    icon: IconType.FROM_NETWORK,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.OUTBOUND
                },
                {
                    label: DirectionFilterNames.INTBOUND,
                    key: 'geo-allow-out',
                    icon: IconType.FROM_INTERNET,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.INTBOUND
                },
                {
                    label: DirectionFilterNames.BOTH,
                    key: 'geo-allow-both',
                    icon: IconType.ARROW_BOTH,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.COUNTRY,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.BOTH
                }
            ]
        }
    ],
    [BulkProtectionOptions.WEB_FILTERING]: [
        {
            label: APPLY_ATT_LABEL,
            key: 'category-att',
            icon: IconType.APPLY_ATT,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkRecommendationType.CATEGORY,
            updatedAction: BulkUpdateAction.RECOMMENDATION
        },
        {
            label: 'Block All Categories',
            key: 'category-block',
            icon: IconType.BLOCK_ICON,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.CATEGORY,
            updatedAction: BulkUpdateAction.BLOCK_ALL,
            updateDirection: BulkUpdateDirection.BOTH
        },
        {
            label: 'Allow All Categories',
            key: 'category-allow',
            icon: IconType.ALLOW_ICON,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.CATEGORY,
            updatedAction: BulkUpdateAction.ALLOW_ALL,
            updateDirection: BulkUpdateDirection.BOTH
        }
    ],
    [BulkProtectionOptions.SERVICES]: [
        {
            label: 'Block All Services',
            key: 'services-block',
            icon: IconType.BLOCK_ICON,
            iconSize: 18,
            selectable: false,
            isSub: false,
            children: [
                {
                    label: DirectionFilterNames.OUTBOUND,
                    key: 'service-block-out',
                    icon: IconType.FROM_NETWORK,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.SERVICES,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.OUTBOUND
                },
                {
                    label: DirectionFilterNames.INTBOUND,
                    key: 'service-block-in',
                    icon: IconType.FROM_INTERNET,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.SERVICES,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.INTBOUND
                }
            ]
        },
        {
            label: 'Allow All Services',
            key: 'service-allow',
            icon: IconType.ALLOW_ICON,
            iconSize: 18,
            selectable: false,
            isSub: false,
            children: [
                {
                    label: DirectionFilterNames.OUTBOUND,
                    key: 'service-allow-in',
                    icon: IconType.FROM_NETWORK,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.SERVICES,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.OUTBOUND
                },
                {
                    label: DirectionFilterNames.INTBOUND,
                    key: 'service-allow-out',
                    icon: IconType.FROM_INTERNET,
                    iconSize: 18,
                    selectable: true,
                    isSub: true,
                    children: null,
                    updateType: BulkUpdateType.SERVICES,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.INTBOUND
                }
            ]
        }
    ],
    [BulkProtectionOptions.ALLOW_LIST]: [
        {
            label: 'Clear Allow List',
            key: 'ip-allow',
            icon: IconType.CLEAR,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.IP_CONTROL_ALLOW_LIST,
            updatedAction: BulkUpdateAction.ALLOW_ALL,
            updateDirection: BulkUpdateDirection.BOTH,
            modalConfirmInfo: {
                title: 'Remove',
                text: 'Remove all allowed IPs?',
                okButtonText: 'Remove'
            }
        }
    ],
    [BulkProtectionOptions.BLOCK_LIST]: [
        {
            label: 'Clear Block List',
            key: 'ip-block',
            icon: IconType.CLEAR,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.IP_CONTROL_BLOCK_LIST,
            updatedAction: BulkUpdateAction.BLOCK_ALL,
            updateDirection: BulkUpdateDirection.BOTH,
            modalConfirmInfo: {
                title: 'Remove',
                text: 'Remove all blocked IPs?',
                okButtonText: 'Remove'
            }
        }
    ],
    [BulkProtectionOptions.DOMAINS]: [
        {
            label: 'Clear all allowed domains',
            key: 'domain-allow',
            icon: IconType.CLEAR,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.DOMAINS_ALLOW,
            updatedAction: BulkUpdateAction.ALLOW_ALL,
            updateDirection: BulkUpdateDirection.BOTH,
            modalConfirmInfo: {
                title: 'Remove',
                text: 'Remove all allowed domains?',
                okButtonText: 'Remove'
            }
        },
        {
            label: 'Clear all blocked domains',
            key: 'domain-block',
            icon: IconType.CLEAR,
            iconSize: 18,
            selectable: true,
            children: null,
            updateType: BulkUpdateType.DOMAINS_BLOCK,
            updatedAction: BulkUpdateAction.ALLOW_ALL,
            updateDirection: BulkUpdateDirection.BOTH,
            modalConfirmInfo: {
                title: 'Remove',
                text: 'Remove all blocked domains?',
                okButtonText: 'Remove'
            }
        },
    ],
    [BulkProtectionOptions.IP_CONTROL]: [
        {
            label: 'Clear IP address list',
            key: 'ip-clear-parent',
            icon: IconType.CLEAR,
            iconSize: 18,
            selectable: false,
            children: [
                {
                    label: 'Clear All',
                    key: 'ip-clear-all',
                    selectable: true,
                    children: null,
                    updateType: BulkUpdateType.IP_CONTROL_ALL,
                    updatedAction: BulkUpdateAction.CLEAR_ALL,
                    updateDirection: BulkUpdateDirection.BOTH,
                    modalConfirmInfo: {
                        title: 'Remove',
                        text: 'Remove all IPs?',
                        okButtonText: 'Remove',
                    },
                },
                {
                    label: 'Clear Allowed IPs',
                    key: 'ip-allow-clear',
                    selectable: true,
                    children: null,
                    updateType: BulkUpdateType.IP_CONTROL_ALLOW_LIST,
                    updatedAction: BulkUpdateAction.ALLOW_ALL,
                    updateDirection: BulkUpdateDirection.BOTH,
                    modalConfirmInfo: {
                        title: 'Remove',
                        text: 'Remove all allowed IPs?',
                        okButtonText: 'Remove',
                    },
                },
                {
                    label: 'Clear Blocked IPs',
                    key: 'ip-block-clear',
                    selectable: true,
                    children: null,
                    updateType: BulkUpdateType.IP_CONTROL_BLOCK_LIST,
                    updatedAction: BulkUpdateAction.BLOCK_ALL,
                    updateDirection: BulkUpdateDirection.BOTH,
                    modalConfirmInfo: {
                        title: 'Remove',
                        text: 'Remove all blocked IPs?',
                        okButtonText: 'Remove',
                    },
                },
            ],
        },
    ],
};